import i18n from '@app/localization/i18n';
import store from '@app/store';
import Category from '@core/models/struct/Category';
import Sport from '@core/models/struct/Sport';
import Tournament from '@core/models/struct/Tournament';

export function tournamentName(tournamentId: number): string {
    const tournaments: Record<number, Tournament> = store.getters['data/sportOffer/tournaments'];
    return tournaments[tournamentId]?.name ?? i18n.t('N/A');
}

export function sportName(sportId: number): string {
    const sports: Record<number, Sport> = store.getters['data/sportOffer/sports'];
    return sports[sportId]?.name ?? i18n.t('N/A');
}

export function categoryName(categoryId: number): string {
    const categories: Record<number, Category> = store.getters['data/sportOffer/categories'];
    return categories[categoryId]?.name ?? i18n.t('N/A');
}

export function tournamentUrlName(tournamentId: number): string {
    const tournaments: Record<number, Tournament> = store.getters['data/sportOffer/tournaments'];
    return tournaments[tournamentId]?.urlName ?? i18n.t('N/A');
}

export function sportUrlName(sportId: number): string {
    const sports: Record<number, Sport> = store.getters['data/sportOffer/sports'];
    return sports[sportId]?.urlName ?? i18n.t('N/A');
}

export function categoryUrlName(categoryId: number): string {
    const categories: Record<number, Category> = store.getters['data/sportOffer/categories'];
    return categories[categoryId]?.urlName ?? i18n.t('N/A');
}
